<section class="wizard-screen">
  <div class="layout-container wizard-layout">
    <aside class="wizard-sidebar" aria-label="Design phases">
      <h2>Design Phases</h2>

      <ol class="step-list">
        <li
          *ngFor="let step of steps; let index = index"
          class="step-item"
          [class.completed]="index < currentStepIndex"
          [class.active]="index === currentStepIndex"
        >
          <button
            type="button"
            class="step-button"
            [attr.aria-current]="index === currentStepIndex ? 'step' : null"
            (click)="goToStep(index)"
          >
            <span class="step-number">{{ step.number }}</span>
            <span class="step-copy">
              <span class="step-title">{{ step.title }}</span>
              <span class="step-subtitle">{{ step.subtitle }}</span>
            </span>
          </button>
        </li>
      </ol>
    </aside>

    <section class="wizard-panel">
      <div class="panel-body" *ngIf="currentStepIndex === 0; else otherSteps">
        <app-step-one [profileForm]="profileForm"></app-step-one>
      </div>

      <ng-template #otherSteps>
        <div class="panel-body" *ngIf="currentStepIndex === 1; else thirdStep">
          <app-step-two
            [uploadSections]="uploadSections"
            [uploadedFiles]="uploadedFiles"
          ></app-step-two>
        </div>
      </ng-template>

      <ng-template #thirdStep>
        <div class="panel-body" *ngIf="currentStepIndex === 2; else fourthStep">
          <app-step-three
            [participantOptions]="participantOptions"
            [exerciseFormats]="exerciseFormats"
            [selectedParticipantIds]="selectedParticipantIds"
            [selectedExerciseFormatId]="selectedExerciseFormatId"
            [customExerciseType]="customExerciseType"
            [objectiveOptions]="objectiveOptions"
            [selectedObjectiveIds]="selectedObjectiveIds"
            [pendingObjectiveIds]="pendingObjectiveIds"
          ></app-step-three>
        </div>
      </ng-template>

      <ng-template #fourthStep>
        <div
          class="panel-body"
          *ngIf="currentStepIndex === 4; else remainingSteps"
        >
          <app-step-five
            [threatSeeds]="stepFourThreatSeeds"
            [selectedThreatSeedIds]="selectedStepFourThreatSeedIds"
            [dragOver]="stepFourDragOver"
            [uploadedFiles]="stepFourFiles"
            [scenarioDescription]="scenarioSeedDescription"
            [scenariosGenerated]="stepFourScenariosGenerated"
            [generationError]="scenarioGenerationError"
            [isGenerating]="isGeneratingScenarios"
            [generatedScenarios]="generatedScenarios"
            [selectedScenarioId]="selectedScenarioId"
            [noFeedbackNeeded]="noFeedbackNeeded"
            [feedbackComment]="scenariofeedbackComment"
          ></app-step-five>
        </div>
      </ng-template>

      <ng-template #remainingSteps>
        <div class="panel-body" *ngIf="currentStepIndex === 3; else sixthStep">
          <app-step-four
            [objectiveOptions]="stepFourObjectiveOptions"
            [selectedObjectiveIds]="selectedStepFourObjectiveIds"
            [customObjectives]="stepFourCustomObjectives"
            [customObjectiveInput]="stepFourCustomObjective"
          ></app-step-four>
        </div>
      </ng-template>

      <ng-template #sixthStep>
        <div
          class="panel-body"
          *ngIf="currentStepIndex === 5; else placeholderStep"
        >
          <app-step-six
            [showLogisticsForm]="showLogisticsForm"
            [generationError]="moduleGenerationError"
            [isGenerating]="isGeneratingModulePlans"
            [durationOptions]="durationOptions"
            [selectedDurationId]="selectedDurationId"
            [(moduleCount)]="moduleCount"
            [(questionCount)]="questionCount"
            [intensityOptions]="intensityOptions"
            [selectedIntensityId]="selectedIntensityId"
            [includeNewsReports]="includeNewsReports"
            [includeSocialFeedSimulation]="includeSocialFeedSimulation"
            [includeInternalEmails]="includeInternalEmails"
            [socialPlatformOptions]="socialPlatformOptions"
            [selectedSocialPlatformIds]="selectedSocialPlatformIds"
            [templateDragOver]="stepSixDragOver"
            [templateFiles]="templateFiles"
            [selectedDurationLabel]="selectedDurationLabel"
            [selectedIntensityTitle]="selectedIntensityTitle"
            [modulePlans]="modulePlans"
          ></app-step-six>
        </div>
      </ng-template>

      <ng-template #placeholderStep>
        <div class="panel-body" *ngIf="currentStepIndex === 6">
          <app-step-seven
            [moduleGenerationError]="moduleGenerationError"
            [selectedScenario]="selectedScenario"
            [documentGenerated]="documentGenerated"
            [isGeneratingDocument]="isGeneratingDocument"
            [documentGenerationError]="documentGenerationError"
            [targetImpactLevel]="targetImpactLevel"
            [redTeamRequested]="redTeamRequested"
            [isRequestingRedTeamReview]="isRequestingRedTeamReview"
            [redTeamError]="redTeamError"
            [critiqueApplied]="critiqueApplied"
            [isApplyingCritique]="isApplyingCritique"
            [documentPreviewContent]="documentPreviewContent"
            [redTeamCritiqueContent]="redTeamCritiqueContent"
            [pptPlanGenerated]="pptPlanGenerated"
            [pptContentGenerated]="pptContentGenerated"
            [pptFileGenerated]="pptFileGenerated"
            [isGeneratingPptPlan]="isGeneratingPptPlan"
            [isGeneratingPptPresentation]="isGeneratingPptPresentation"
            [pptPlanError]="pptPlanError"
            [pptPresentationError]="pptPresentationError"
            [pptContentSlides]="pptContentSlides"
            [currentPptPreviewSlideIndex]="currentPptPreviewSlideIndex"
            [crisisImagesGenerated]="crisisImagesGenerated"
            [isGeneratingCrisisImages]="isGeneratingCrisisImages"
            [crisisImagesError]="crisisImagesError"
            [crisisImagePreviews]="crisisImagePreviews"
            [generateDocument]="generateDocument.bind(this)"
            [requestRedTeamReview]="requestRedTeamReview.bind(this)"
            [applyCritique]="applyCritique.bind(this)"
            [generatePowerPointPlan]="generatePowerPointPlan.bind(this)"
            [generatePowerPointPresentation]="
              generatePowerPointPresentation.bind(this)
            "
            [downloadPptPresentation]="downloadPptPresentation.bind(this)"
            [generateCrisisImages]="generateCrisisImages.bind(this)"
            [downloadCrisisImage]="downloadCrisisImage.bind(this)"
            [goToStep]="goToStep.bind(this)"
          ></app-step-seven>
        </div>
      </ng-template>

      <footer class="panel-footer">
        <button
          type="button"
          class="footer-button footer-button-secondary"
          (click)="previous()"
          [disabled]="isGeneratingScenarios || isGeneratingModulePlans"
        >
          Back
        </button>

        <div class="footer-primary-area">
          <button
            type="button"
            class="footer-button footer-button-primary"
            [class.footer-button-loading]="
              isGeneratingScenarios || isGeneratingModulePlans
            "
            (click)="next()"
            [disabled]="
              currentStepIndex === steps.length - 1 ||
              isGeneratingScenarios ||
              isGeneratingModulePlans
            "
          >
            {{ primaryButtonLabel }}
          </button>
        </div>
      </footer>
    </section>
  </div>

  <!-- Modal de confirmación para salir del paso 7 -->
  <div
    class="modal-overlay"
    *ngIf="showBackConfirmationModal"
    (click)="cancelBackToProcess()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <h2 class="modal-title">Back to the process</h2>
      <p class="modal-message">
        Once you agree to go back to the previous steps, all the progress made
        in the "Final Output" step will be lost. Do you agree to this?
      </p>
      <div class="modal-actions">
        <button
          type="button"
          class="modal-button modal-button-cancel"
          (click)="cancelBackToProcess()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="modal-button modal-button-confirm"
          (click)="confirmBackToProcess()"
        >
          Continue
        </button>
      </div>
    </div>
  </div>

  <!-- Full-page loading overlay for AI generation -->
  <div
    class="generation-overlay"
    *ngIf="isGeneratingScenarios || isGeneratingModulePlans"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="generation-overlay-inner">
      <p class="generation-overlay-label">
        {{ isGeneratingScenarios ? "Scenario Generation" : "Module Planning" }}
      </p>
      <h2 class="generation-overlay-title">
        {{
          isGeneratingScenarios ? "Analyzing threats…" : "Building module plan…"
        }}
      </h2>
      <p class="generation-overlay-hint">
        {{
          isGeneratingScenarios
            ? "AI is synthesizing your context with real-world threat intelligence"
            : "AI is structuring your exercise modules based on the selected scenario"
        }}
      </p>
    </div>
  </div>
</section>
